module.exports = __webpack_public_path__ + "static/media/o2.889d5855.svg";